import { Paper } from "@mui/material";
import CreateWebhookForm from "../../../organisms/Webhook/CreateWebhookForm";

export default function CreateWebhookPage() {
  return (
    <Paper>
      <CreateWebhookForm />
    </Paper>
  );
}
